
<template>
  <!-- 周年庆留言板 -->
  <GuestBook v-if="isGlobal && customSetting?.carnivalSwitch"/>
  <!-- 推广位 -->
  <div class="promotion" v-if="bannerList.length || recommendeList.length">
    <!-- banner图 -->
    <swiper
      @slideChange="changeSwiper"
      v-if="bannerList.length"
      :class="`swiper-container ${bannerList.length > 1 ? '' : 'nonavigation'}`"
      class="my-swpie"
      :space-between="30"
      :modules="modules"
      navigation
      :loop="true"
      :autoplay="{
        delay: 5000,
      }"
    >
      <swiper-slide v-for="(banner, index) in bannerList" :key="index">
        <ObImg 
          width="1200px"
          height="432px"
          :duration="0"
          :src="banner.image"
          :fetchpriority="!index ? 'high' : 'auto'"
          :lazy="!!index"
          @click="onJump(banner.webLink, index)" 
        />
      </swiper-slide>
    </swiper>
    <!-- 推荐卡片 -->
    <dl class="recommeded-wrap" v-if="recommendeList?.length">
      <p class="recommeded-title">{{ $t('recommended') }}</p>
      <dt class="recommeded-card">
        <RecommendedCard 
          v-for="(recommended, index) in recommendeList"
          :key="index"
          :recommendedData="recommended"
          :index="index + 1"
        />
      </dt>
    </dl>
  </div>
  <!-- 主要内容 -->
  <MainContainer v-if="showMain"/>
</template>

<script setup> 
import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia'
import http from '@/service'

// 组件
import MainContainer from './component/mainContainer'
import GuestBook from '@/views/activities/guestbook'

// swiper： Navigation（导航标） Pagination（分页器） Autoplay（自动播放）
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const modules = [Navigation, Pagination, Autoplay]

const route = useRoute()
const systemStore = useSystemStore()  // 用户仓库
const { isApp, customSetting } = storeToRefs(systemStore)   // 用户id
const { proxy } = getCurrentInstance()

const showMain = ref(false)

const isGlobal = ref(import.meta.env.VITE_COUNTRY === 'GLOBAL')

const bannerList = ref([])    // banner图列表
const gaBannerView = ref([])
const recommendeList = ref([]) // 推荐列表


const changeSwiper = (val) => {
  nextTick(() => {
    // 如果不在可视区域、不触发埋点
    if (!document.querySelector('.my-swpie') || document.querySelector('.my-swpie').getBoundingClientRect().y < -365) return
    if (val.activeIndex > bannerList.value.length) {
      return
    }
    if (!gaBannerView.value.includes(val.activeIndex)) {
      gaBannerView.value.push(val.activeIndex)
      proxy.$ga('homepage_banner_impression', {
        "screen_name": route.name,
        "destination": bannerList.value[val.activeIndex - 1]?.webLink,
        "position": String(val.activeIndex)
      })
    }
  })
}

// 获取banner列表
async function getBannerList () {
  let response = null
  try {
    response = JSON.parse(document.getElementById('home-banner-list').innerText) ?? {}
  } catch {}
  if (!response || response?.code !==200) {
    response = await http.getBannerList() || {}
  }
  const { code, data } = response
  if (code !== 200 || !data) return
  bannerList.value = [...data]
}

// 获取推荐卡片,只展示3个或6个
async function getRecommendedCard () {
  let response = null
  try {
    response = JSON.parse(document.getElementById('recommend-banner-list').innerText) ?? {}
  } catch {}
  if (!response || response?.code !==200) {
    response = await http.getRecommendedCard() || {}
  }
  const { code, data } = response
  if (code !== 200 || !data?.length) return
  if (data.length >= 6) {
    recommendeList.value = [...data.slice(0, 6)]
  } else {
    recommendeList.value = [...data.slice(0, 3)]
  }
}

const onJump = (webLink, index) => {
  proxy.$ga('homepage_banner_entry', {
    "screen_name": route.name,
    "destination": webLink,
    "position": index
  })
  if (isApp.value) {
    proxy.$openNewWebview(webLink)
  } else {
    if (webLink.includes(location.origin)) {
      location.href = webLink
    } else {
      window.open(webLink)
    }
  }
}

onBeforeMount(async () => {
  getBannerList()
  getRecommendedCard()
  showMain.value = true
})

</script>

<style lang="postcss" scoped>
.promotion {
  min-width: 1200px;
  padding: 40px 0 50px;
  background-color: #F9F9F9;
  min-height: 432px;
}
/* 自定义swiper导航箭头 */
.nonavigation {
  &:hover {
    :deep(.swiper-button-prev) {
      display: none !important;
    }
    :deep(.swiper-button-next) {
      display: none !important;
    }
  }
}
.swiper-container {
  width: 1200px;
  height: 432px;
  --swiper-theme-color: #1989fa; /* 设置Swiper风格 */
  --swiper-navigation-color: #818081; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 20px; /* 设置按钮大小 */
  & :deep(.ob-image)  {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  
  :deep(.swiper-button-prev) {
    display: none;
    left: 20px;
    &:hover {
      color: #ffffff;
    }
  }
  :deep(.swiper-button-next) {
    display: none;
    right: 20px;
    &:hover {
      color: #ffffff;
    }
  }
  &:hover {
    :deep(.swiper-button-prev) {
      display: flex;
      margin-top: unset;
      transform: translateY(-10px);
      &:hover {
        color: #ffffff;
      }
    }
    :deep(.swiper-button-next) {
      display: flex;
      margin-top: unset;
      transform: translateY(-10px);
      &:hover {
        color: #ffffff;
      }
    }
  }
}

.recommeded-wrap {
  display: flex;
  flex-flow: column wrap;
  margin: 24px auto 0;
  width: 1200px;
  .recommeded-title {
    font-size: 28px;
    margin-bottom: 19px;
  }
  .recommeded-card {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    
    
  }
}

</style>